import { render, staticRenderFns } from "./customSettings.vue?vue&type=template&id=71113b9a&scoped=true&"
import script from "./customSettings.vue?vue&type=script&lang=js&"
export * from "./customSettings.vue?vue&type=script&lang=js&"
import style0 from "./customSettings.vue?vue&type=style&index=0&id=71113b9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71113b9a",
  null
  
)

export default component.exports